import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';
import {fadeLoop} from '../../styles/keyframes/keyframes';
import {isIE11} from '../../helpers/ie.helper';

export const Container = styled.div`
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: 300;
  position: relative;
  background-color: ${p => p.theme.primaryColor};
  ${isIE11() && `
    max-width: 100%;
    overflow: hidden;
  `}
`;

export const Arrow = styled.img`
  position: absolute;
  right: 2rem;
  bottom: 9rem;
  color: ${p => p.theme.primaryColor};
  height: 4rem;
  width: 4rem;
  z-index: 99;
  cursor: pointer;
  transform: rotate(270deg);
  opacity: 0.8;
  animation: ${fadeLoop} 2s infinite;
  ${media.small`
    right: 0;
    bottom: 1rem;
  `};
`;

export const CommonWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 10rem 1rem;
  ${media.medium`
    padding: 8rem 0;
  `};
  ${media.small`
    padding: 8rem 0 4rem;
  `};
`;

export const CommonContent = styled.div`
  width: ${props => props.theme.container.wider.width};
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${p => p.theme.textColor};
  ${media.medium`
    width: 100%;
  `};
`;

export const CommonTitle = styled.div`
  font-family: 'Montserrat', sans-serif;
  font-size: 4rem;
  line-height: 4.4rem;
  text-transform: uppercase;
  letter-spacing: 0.2rem;
  margin-bottom: 1.2rem;
  text-align: center;
  ${media.medium`
    font-size: 3.6rem;
    line-height: 4rem;
  `};
  ${media.small`
    font-size: 2.8rem;
    line-height: 3.2rem;
  `};
  ${media.smaller`
    font-size: 2.4rem;
    line-height: 3rem;
  `};
  ${isIE11() && `
    width: 100%;
  `}
`;

export const CommonSubTitle = styled.div`
  text-align: center;
  font-size: 1.4rem;
  text-transform: uppercase;
  width: 70%;
  letter-spacing: 0.2rem;
  padding: 0 1rem;
  margin-bottom: 1.2rem;
  ${media.small`
    width: 80%;
  `};
  ${isIE11() && `
    width: 100%;
  `}
`;

export const CommonBody = styled.div`
  font-size: 1.8rem;
  letter-spacing: 0.2rem;
  padding: 1rem;
  margin-bottom: 1.2rem;
  white-space: pre-line;
  max-width: 100%;
  flex-basis: 100%;
  ${isIE11() && `
    flex-basis: auto;
  `}
`;

export const StripOverlay = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 8rem 20%;
  background: ${p => `linear-gradient(to left, ${p.firstColor}, ${p.secondColor})`};
  ${media.medium`
    padding: 8rem 10%;
  `};
  ${media.small`
    padding: 6rem 6%;
  `};
`;

export const DarkBlock = styled.div`
  background-color: #444;
  width: 100%;
  text-align: center;
  padding: 6rem 4rem;
  ${media.small`
    padding: 4rem;
  `};
`;

export const SpecialOfferWrapper = styled.div`
  margin: 0 auto;
`;



// WEBPACK FOOTER //
// ./containers/LightHomePage/LightHomePage.style.js